var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
import React from 'react';
import { connect } from 'react-redux';
import * as padLeft from 'pad-left';
import Col from 'antd/lib/grid/col';
import Row from 'antd/lib/grid/row';
import 'antd/lib/grid/style/index.css';
import message from 'antd/lib/message';
import 'antd/lib/message/style/index.css';
import Page from '../../templates/Page';
import CardGenerator from './CardGenerator';
var PageScorecard = (function (_super) {
    __extends(PageScorecard, _super);
    function PageScorecard(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {};
        _this.setFilters = _this.setFilters.bind(_this);
        _this.handleGenerateScorecards = _this.handleGenerateScorecards.bind(_this);
        return _this;
    }
    PageScorecard.prototype.setFilters = function (filter) {
        var newFilter = __assign({}, this.state, filter);
        this.setState(__assign({}, newFilter));
    };
    PageScorecard.prototype.handleGenerateScorecards = function () {
        var _this = this;
        var category = this.props.store.categories.find(function (c) { return c.id === _this.state.filterCategory; });
        var round = this.props.store.rounds.find(function (r) { return r.id === _this.state.filterRound; });
        var routes = this.props.store.routes
            .filter(function (r) { return round && r.roundId === round.id; })
            .sort(function (a, b) { return a.index - b.index; });
        var athletes = this.props.store.athletes
            .filter(function (a) { return category && a.categoryId === category.id; });
        if (!category || !round || routes.length < 1) {
            return;
        }
        var eventName = this.props.store.event.name;
        var roundName = round.name + ", " + category.name;
        var routeNames = routes.map(function (r) { return "" + round.code + (r.index + 1); });
        var athleteScores = this.props.store.athleteScores
            .filter(function (aS) { return aS.roundId === round.id; })
            .sort(function (a, b) { return a.bibNumber - b.bibNumber; });
        var scoreCardData = athleteScores.map(function (aS) {
            var athlete = athletes.find(function (a) { return a.id === aS.athleteId; });
            return {
                eventName: eventName,
                roundName: roundName,
                routeNames: routeNames,
                athleteName: athlete ? athlete.name : '',
                athleteBib: round.code + "\n" + padLeft(aS.bibNumber, 3, '0'),
            };
        });
        try {
            var pdfWorker_1 = new Worker('/workers/generate-scorecards.js');
            pdfWorker_1.onmessage = function (res) {
                pdfWorker_1.terminate();
                var $download = window.document.createElement('a');
                $download.style.cssText = 'display: none;';
                $download.href = window.URL.createObjectURL(res.data.pdfBlob);
                $download.download = "Scorecards for " + round.name + " " + category.name + ".pdf";
                $download.click();
            };
            pdfWorker_1.onerror = function (err) {
                pdfWorker_1.terminate();
            };
            pdfWorker_1.postMessage(scoreCardData);
        }
        catch (err) {
            message.error(err.message);
        }
    };
    PageScorecard.prototype.render = function () {
        return (React.createElement(Page, { documentTitle: "Generate Scorecards | " + this.props.store.event.nameShort, pageContentMaxWidth: '1024px', pageTitle: 'Generate Scorecards' },
            React.createElement(Row, { gutter: 24 },
                React.createElement(Col, { xs: {
                        span: 24,
                        push: 0,
                    }, xl: {
                        span: 8,
                        push: 16,
                    } }),
                React.createElement(Col, { xs: {
                        span: 24,
                        push: 0,
                    }, xl: {
                        span: 16,
                        pull: 8,
                    } },
                    React.createElement(CardGenerator, { event: this.props.store.event, categories: this.props.store.categories, rounds: this.props.store.rounds, athleteScores: this.props.store.athleteScores, filterCategory: this.state.filterCategory, filterRound: this.state.filterRound, setFilters: this.setFilters, handleGenerateScorecards: this.handleGenerateScorecards })))));
    };
    return PageScorecard;
}(React.Component));
var mapStateToProps = function (state) { return ({
    store: {
        event: state.workspaceEvent.event && state.workspaceEvent.event.data[0],
        categories: state.workspaceEvent.categories && state.workspaceEvent.categories.data,
        rounds: state.workspaceEvent.rounds && state.workspaceEvent.rounds.data,
        routes: state.workspaceEvent.routes && state.workspaceEvent.routes.data,
        athletes: state.workspaceEvent.athletes && state.workspaceEvent.athletes.data,
        athleteScores: state.workspaceEvent.athleteScores && state.workspaceEvent.athleteScores.data,
    },
}); };
export default connect(mapStateToProps)(PageScorecard);



//////////////////
// WEBPACK FOOTER
// ./src/pages/WorkspaceEvent/PageScorecard/index.tsx
// module id = 1321
// module chunks = 0